export const storage = {
  /**
   * 设置存储项
   * @param {string} key 键名
   * @param {any} value 值 (对象会自动转为JSON)
   */
  set(key, value) {
    try {
      const jsonValue = JSON.stringify(value);
      localStorage.setItem(key, jsonValue);
      return true;
    } catch (e) {
      return false;
    }
  },

  /**
   * 获取存储项
   * @param {string} key 键名
   * @param {any} defaultValue 默认值 (可选)
   * @return {any} 存储的值或默认值
   */
  get(key, defaultValue = null) {
    try {
      const jsonValue = localStorage.getItem(key);
      return jsonValue ? JSON.parse(jsonValue) : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  },

  /**
   * 移除存储项
   * @param {string} key 键名
   */
  remove(key) {
    localStorage.removeItem(key);
  },

  /**
   * 清空所有存储
   */
  clear() {
    localStorage.clear();
  },

  /**
   * 检查是否存在某个键
   * @param {string} key 键名
   * @return {boolean}
   */
  has(key) {
    return localStorage.getItem(key) !== null;
  },

  /**
   * 获取所有键名
   * @return {string[]}
   */
  keys() {
    return Object.keys(localStorage);
  }
};
